import ProgramacaoNova from './ProgramacaoNova';

export default ProgramacaoNova;